import { useState } from "react";
import { Link } from "react-router-dom";
import { X, BookOpen, ArrowRight, MessageCircle, MessageSquareText } from "lucide-react";
import { openGayle } from "@/components/app/GaylePanel";
import { useAuth } from "@/context/AuthContext";
import SponsorDigestCard from "@/components/app/SponsorDigestCard";

export const KEY = (id) => `changeos_prompts_dismissed_${id}`;
export const read = (id) => { try { return JSON.parse(localStorage.getItem(KEY(id)) || "[]"); } catch { return []; } };

// Contextual guidance: a colleague leaning over, not a compliance system. Calm, dismissible, links to Learn.
export default function Prompts({ change, onGo }) {
  const { can } = useAuth();
  const [dismissed, setDismissed] = useState(() => read(change.id));
  const items = (change.prompts || []).filter((p) => !dismissed.includes(p.key));
  if (items.length === 0) return null;
  const dismiss = (k) => { const next = [...dismissed, k]; setDismissed(next); localStorage.setItem(KEY(change.id), JSON.stringify(next)); };
  return (
    <div className="mt-5 space-y-2" data-testid="prompts">
      {items.map((p) => (
        <div key={p.key} data-testid={`prompt-${p.kind}`} data-quiet={p.quiet ? "true" : "false"} className={`rounded-2xl border p-4 flex gap-3 items-start ${p.quiet ? "border-border-soft bg-muted" : "border-border bg-card"}`}>
          <span className="mt-0.5 w-7 h-7 rounded-full bg-accent-50 text-accent-700 flex items-center justify-center shrink-0"><MessageCircle size={14} /></span>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-bold text-foreground" data-testid={`prompt-title-${p.kind}`}>{p.title}</div>
            <p className="text-sm text-subtle mt-0.5 leading-relaxed">{p.body}</p>
            {p.action === "digest" && <SponsorDigestCard change={change} compact />}
            <div className="flex flex-wrap gap-3 mt-2 text-xs font-bold">
              <button data-testid={`prompt-go-${p.kind}`} onClick={() => onGo(p.tab, p)} className="inline-flex items-center gap-1 text-accent-700 hover:text-accent-900">Go there <ArrowRight size={12} /></button>
              <Link data-testid={`prompt-learn-${p.kind}`} to={`/app/learn/${p.learn}?change=${change.id}`} className="inline-flex items-center gap-1 text-subtle hover:text-foreground"><BookOpen size={12} /> Read why</Link>
              {can("ai") && <button data-testid={`prompt-ask-${p.kind}`} onClick={() => openGayle({ changeId: change.id, seed: `${p.title}. What should I do about it?` })} className="inline-flex items-center gap-1 text-subtle hover:text-foreground"><MessageSquareText size={12} /> Ask Gayle about this</button>}
            </div>
          </div>
          <button data-testid={`prompt-dismiss-${p.kind}`} onClick={() => dismiss(p.key)} title="Dismiss" className="text-faint hover:text-subtle transition-colors"><X size={15} /></button>
        </div>
      ))}
    </div>
  );
}
